import { auto } from '@popperjs/core'
import { FC } from 'react'
import Select from 'react-select'

type Props = {
    onChange?: any
    options?: any
    isMulti?: any
    value?: any
    className?: any
    isLoading?: boolean
    placeholder?:any
    isclearable?:any
}

const CustomSelect: FC<Props> = ({ onChange, options, isMulti, value, isLoading, className,placeholder,isclearable }) => {

    const customStyles = {
        control: (base: any) => ({
            ...base,
            background: '#f5f8fa',
            border: 'none',
            borderRadius: '7px'
        }),
    }

    const defaultValue = (options: any, value: any) => {
        if (isMulti === undefined) {
            return options ? options.find((option: any) => option.value === value) : ""
        }
        else {
            var returnValue = [];
            if (value !== undefined) {
                var valArray = value;
                for (var i = 0; i < valArray.length; i++) {
                    returnValue.push(options ? options.find((option: any) => option.value === valArray[i]) : "");
                }
                return returnValue;
            }
            else {
                return "";
            }
        }
        // return options ? options.find((option:any)=>option.value === value):""
    }
    return (
        <div className={className}>
            <Select
                styles={customStyles}
                value={defaultValue(options, value) || null}
                isMulti={isMulti}
                onChange={(value:any) => onChange(value)}
                options={options}
                isLoading={isLoading || false}
                isClearable={isclearable}
                placeholder={placeholder}
            />
        </div>
    )
}
export { CustomSelect }